import { useEffect } from 'react';
import debounce from 'lodash/debounce';

export const useWindowResize = (cb: () => void, delay = 500) => {
  useEffect(() => {
    const debounceCb = debounce(cb, delay, { trailing: true, leading: false });

    window.addEventListener('resize', debounceCb);
    return () => {
      window.removeEventListener('resize', debounceCb);
    };
  }, [cb, delay]);
};
